import { useQuery } from "@tanstack/react-query";
import axios from "../services/api/api";

const FetchLicenseManagementCustomers = async () => {
  const res = await axios.get(`/LicMgt/GetCustomers`);
  return res.data.result;
};
export function GetLicenseManagementCustomers() {
  return useQuery({
    queryKey: ["FetchLicenseManagementCustomers"],
    queryFn: () => FetchLicenseManagementCustomers(),
    retry: 3,
  });
}

const FetchLicenseManagementCourses = async () => {
  const res = await axios.get(`/LicMgt/GetCourses`);
  return res.data.result;
};
export function GetLicenseManagementCourses() {
  return useQuery({
    queryKey: ["FetchLicenseManagementCourses"],
    queryFn: () => FetchLicenseManagementCourses(),
    retry: 3,
  });
}

const FetchCustomerGroups = async () => {
  const res = await axios.get(`/School/GetGroups`);
  return res.data.result;
};
export function GetCustomerGroups() {
  return useQuery({
    queryKey: ["FetchCustomerGroups"],
    queryFn: () => FetchCustomerGroups(),
    retry: 3,
  });
}
